import { render, staticRenderFns } from "./CowsLIstPage.vue?vue&type=template&id=09f543cc&scoped=true&"
import script from "./CowsLIstPage.vue?vue&type=script&lang=js&"
export * from "./CowsLIstPage.vue?vue&type=script&lang=js&"
import style0 from "./CowsLIstPage.vue?vue&type=style&index=0&id=09f543cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f543cc",
  null
  
)

export default component.exports